// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__KLS49","buttons":"PendingPaymentAlert_buttons__1Qlgi"};